export default __webpack_public_path__ + "7643689e6b6098cd3a993a0f6d9f839d.png";